import { useEffect, useState } from "react";
import { ButtonSize, IconSize } from "../../classes/enums/ButtonEnum";
import { getIconSizeClass } from "../../classes/utils/UiUtils";
import { iconMapping } from "../../config/iconConfig";
import Tooltip, { TooltipOrientation } from "../tooltip/Tooltip";
import "./IconButton.css";

function IconButton({
  icon,
  iconSize = IconSize.DEFAULT,
  size = ButtonSize.DEFAULT,
  isCircle = true,
  isLightBlue = true,
  noBgColor = false,
  disabled = false,
  onClick = () => {},
  onMouseDown = () => {},
  title,
  tooltipContent,
  tooltipOrientation = TooltipOrientation.Top,
  isTogglable = false,
  isToggled = false,
  onToggle,
  ...props
}) {
  const [toggled, setToggled] = useState(isToggled);

  // Update internal state when prop changes
  useEffect(() => {
    if (!isTogglable) {
      return;
    }
    setToggled(isToggled);
  }, [isTogglable, isToggled]);

  const IconComponent = iconMapping[icon];

  const getSizeClass = () => {
    switch (size) {
      case ButtonSize.MICRO:
        return "App-icon-button-micro";
      case ButtonSize.SMALL:
        return "App-icon-button-small";
      case ButtonSize.MEDIUM:
        return "App-icon-button-medium";
      case ButtonSize.LARGE:
        return "App-icon-button-large";
      case ButtonSize.XLARGE:
        return "App-icon-button-xlarge";
      case ButtonSize.DEFAULT:
      default:
        return "";
    }
  };

  const handleClick = e => {
    const newToggledState = !toggled;
    setToggled(newToggledState);

    // Call both the toggle handler and the normal onClick handler
    if (onToggle) {
      onToggle(newToggledState);
    }
    onClick(e);
  };

  return (
    <div
      // title={title}
      onClick={handleClick}
      onMouseDown={onMouseDown}
      className={`App-icon-button 
        ${isCircle ? "App-icon-button-circle" : "App-icon-button-long"}
        ${getSizeClass()}
        ${
          !noBgColor
            ? isLightBlue
              ? "App-icon-button-light"
              : "App-icon-button-dark"
            : ""
        }
        ${toggled && isTogglable ? "App-icon-button-toggled" : ""}
        ${disabled ? "disabled" : ""}
        ${props.className}`}
    >
      {IconComponent && (
        <div className={getIconSizeClass(iconSize)}>
          {title || tooltipContent ? (
            <Tooltip
              text={title}
              content={tooltipContent}
              orientation={tooltipOrientation}
            >
              <IconComponent />
            </Tooltip>
          ) : (
            <IconComponent />
          )}
        </div>
      )}
    </div>
  );
}

export default IconButton;
